import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import CameraMap from "../LocationMap";

const Dashboard = () => {
  return (
    <DashboardLayout>
      <CameraMap />
    </DashboardLayout>
  );
};

export default Dashboard;
